class PositionHelper {
  static getBoundsOfObject(object) {
    return this.getBounds(object.position, object.dimensions);
  }

  static isOverlapping(bounds1, bounds2) {
    return (
      bounds1.xMin < bounds2.xMax &&
      bounds2.xMin < bounds1.xMax &&
      bounds1.yMin < bounds2.yMax &&
      bounds2.yMin < bounds1.yMax
    );
  }

  static getBounds(position, dimensions) {
    return {
      xMin: Math.round(position.x),
      xMax: Math.round(position.x + dimensions.width),
      yMin: Math.round(position.y),
      yMax: Math.round(position.y + dimensions.height),
    };
  }
}

export default PositionHelper;
